import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import THEME from 'theme';
import { Input } from 'components/chroma';

interface SelectProps {
  id?: string;
  fieldName: string;
  value: string;
  ariaLabel?: string;
  onChange: Function;
  required?: boolean;
  valid: boolean;
  isLoading: boolean;
  ariaRequired?: boolean;
}

const SelectContainer = styled.div`
  min-height: 56px;

  select::-ms-expand {
    display: none;
  }

  select {
    -webkit-appearance: none;
    appearance: none;
    padding: 0.8em;
    min-width: 100% !important;
    width: 100% !important;
    color: #000;

    min-height: 48px !important;
    border: 1px solid ${THEME.FIELD.BORDER.DEFAULT};
    border-radius: 6px;
    font-size: 1em;
    font-weight: 300;

    background: url('data:image/svg+xml;charset=UTF-8,<svg xmlns="http://www.w3.org/2000/svg" width="284.929" height="284.929"><path fill="%23cc0001" d="M282.082 76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856-2.471 0-4.661.95-6.563 2.856L142.466 174.441 30.262 62.241c-1.903-1.906-4.093-2.856-6.567-2.856-2.475 0-4.665.95-6.567 2.856L2.856 76.515C.95 78.417 0 80.607 0 83.082c0 2.473.953 4.663 2.856 6.565l133.043 133.046c1.902 1.903 4.093 2.854 6.567 2.854s4.661-.951 6.562-2.854L282.082 89.647c1.902-1.903 2.847-4.093 2.847-6.565 0-2.475-.945-4.665-2.847-6.571z"/></svg>')
      no-repeat;
    background-size: 1em;
    background-position: right 0.8em top 50%;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    option {
      width: 100% !important;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  select:hover {
    background-color: ${THEME.BACKGROUND.WHITE};
  }

  .select-is-valid {
    border-color: ${THEME.FIELD.BORDER.VALID} !important;
    border-width: ${THEME.FIELD.BORDER.SELECTED};
  }
`;

export const Select: FunctionComponent<SelectProps> = ({
  id,
  fieldName,
  value,
  ariaLabel,
  onChange,
  required,
  valid,
  isLoading,
  children,
  ariaRequired,
}) => (
  <>
    {isLoading ? (
      <Input loading />
    ) : (
      <SelectContainer>
        <select
          id={id}
          name={fieldName}
          value={value}
          aria-label={ariaLabel}
          onChange={(event) => {
            onChange(event, event.target.value);
          }}
          required={required}
          className={valid ? 'select-is-valid' : ''}
          aria-required={ariaRequired}
        >
          {children}
        </select>
      </SelectContainer>
    )}
  </>
);

export default Select;
